import {
  AUTH_EXPIRE_TOKEN,
  AUTH_LOGIN,
  AUTH_LOGIN_COMPLETED,
  AUTH_LOGIN_FAILED, AUTH_LOGOUT,
  AUTH_REFRESH,
  AUTH_REFRESH_COMPLETED,
  AUTH_REFRESH_FAILED
} from "./actions";
import {RESTORE_STATE} from "../persistState";

const defaultState = {
  token: null,
  error: null,
  loading: false,
  refreshing: false,
  refreshError: null,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case RESTORE_STATE: {
      if (!action.payload || !action.payload.auth) return defaultState;
      const {token} = action.payload.auth;
      return {
        ...defaultState,
        token,
      };
    }
    case AUTH_LOGIN: {
      return {...state, loading: true};
    }
    case AUTH_LOGIN_COMPLETED: {
      return {...state, loading: false, error: null, token: action.payload};
    }
    case AUTH_LOGIN_FAILED: {
      return {...state, loading: false, error: action.error};
    }
    case AUTH_REFRESH: {
      return {...state, refreshing: true, refreshError: null};
    }
    case AUTH_REFRESH_COMPLETED: {
      return {...state, refreshing: false, token: action.payload};
    }
    case AUTH_REFRESH_FAILED: {
      const token = (action.statusCode >= 400 && action.statusCode < 500) ? null : state.token;
      return {...state, refreshing: false, token, refreshError: action.error};
    }
    case AUTH_EXPIRE_TOKEN: {
      return {...state, token: null};
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Auth/reducer.js